import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  PoBreadcrumb,
  PoDialogService,
  PoNotificationService,
  PoTableAction,
  PoTableColumn,
} from '@po-ui/ng-components';
import { InventarioResumo, GerarExcel } from '../interface/inventario';
import { InventarioService } from '../service/inventario.service';
import { ExcelService } from 'src/app/service/excel-service';

@Component({
  selector: 'app-inventario-lista',
  templateUrl: './inventario-lista.component.html',
  styleUrls: ['./inventario-lista.component.css'],
})
export class InventarioListaComponent implements OnInit {

  itens: Array<InventarioResumo> = [];
  modoInventariar: boolean = false;
  acoes: Array<PoTableAction> = [];

  constructor(
    private inventarioService: InventarioService,
    private excelService: ExcelService,
    private route: ActivatedRoute,
    private router: Router,
    private poDialogService: PoDialogService,
    private poNotificationService: PoNotificationService,
  ) {}

  ngOnInit(): void {
    this.modoInventariar = this.route.snapshot.data['modo'] === 'inventariar';
    this.acoes = this.montarAcoes();
    this.carregar();
  }

  carregar(): void {
    this.inventarioService.lista().subscribe((lista) => {
      this.itens = this.modoInventariar
        ? lista.items.filter((item) => item.CZ08STATUS === '1')
        : lista.items;
    });
  }

  get tituloPagina(): string {
    return this.modoInventariar ? 'Inventariar - Lista' : 'Novo Inventário - Lista';
  }

  get breadcrumb(): PoBreadcrumb {
    return {
      items: [
        { label: 'Estoque', action: () => this.router.navigateByUrl('') },
        { label: this.modoInventariar ? 'Inventariar' : 'Novo Inventário' },
      ],
    };
  }

  public readonly colunas: Array<PoTableColumn> = [
    { property: 'CZ08COD', label: 'Código', width: '120px' },
    { property: 'DZ08DATA', label: 'Data', width: '120px', type: 'date', format: 'dd/MM/yyyy' },
    {
      property: 'CZ08STATUS', label: 'Status', type: 'label',
      labels: [
        { value: '1', color: 'color-08', label: 'Em Andamento' },
        { value: '2', color: 'color-07', label: 'Encerrado' },
      ],
    },
  ];

  private montarAcoes(): Array<PoTableAction> {
    const acoesInventariar: Array<PoTableAction> = [
      {
        label: 'Inventariar',
        action: (row: InventarioResumo) => this.router.navigateByUrl(`/estoque/inventario/inventariar/${row.CZ08COD}`),
        disabled: (row: InventarioResumo) => row.CZ08STATUS !== '1',
      },
      {
        label: 'Visualizar',
        action: (row: InventarioResumo) => this.router.navigateByUrl(`/estoque/inventario/visualizar/${row.CZ08COD}`),
      },
      
    ];

    if (this.modoInventariar) {
      return acoesInventariar;
    }

    return [
      {
        label: 'Editar',
        action: (row: InventarioResumo) => this.router.navigateByUrl(`/estoque/inventario/editar/${row.CZ08COD}`),
        disabled: (row: InventarioResumo) => row.CZ08STATUS !== '1',
      },
      {
        label: 'Excluir',
        action: (row: InventarioResumo) => this.confirmarExclusao(row),
        disabled: (row: InventarioResumo) => row.CZ08STATUS !== '1',
      },
      {
        label: 'Encerrar Inventário',
        action: (row: InventarioResumo) => this.confirmarEncerramento(row),
        disabled: (row: InventarioResumo) => row.CZ08STATUS !== '1',
      },

      {
        label: 'Excel',
        action: (row: InventarioResumo) => this.gerarExcelRelatorio(row),
      },
      ...acoesInventariar,
    ];
  }

  confirmarExclusao(row: InventarioResumo): void {
    this.poDialogService.confirm({
      title: 'Excluir Inventário',
      message: `Deseja realmente excluir o inventário ${row.CZ08COD}?`,
      confirm: () => {
        this.inventarioService.excluirInventario(row.CZ08COD).subscribe(() => {
          this.poNotificationService.success('Inventário excluído com sucesso!');
          this.carregar();
        });
      },
    });
  }

  confirmarEncerramento(row: InventarioResumo): void {
    this.poDialogService.confirm({
      title: 'Encerrar Inventário',
      message: `Deseja realmente encerrar o inventário ${row.CZ08COD}? Esta ação não pode ser desfeita.`,
      confirm: () => {
        this.inventarioService.encerrarInventario(row.CZ08COD).subscribe(() => {
          this.poNotificationService.success('Inventário encerrado com sucesso!');
          this.carregar();
        });
      },
    });
  }

  novoInventario(): void {
    this.router.navigateByUrl('/estoque/inventario/novo');
  }

  gerarExcelRelatorio(row: InventarioResumo): void {
    this.inventarioService.getInventario(row.CZ08COD).subscribe((inventario) => {
      const lista_excel = inventario.items.map((item) => {
        const dadosExcel: GerarExcel = {
          'CZ08COD': inventario.CZ08COD,
          'CB8PRODUTO': item.CB1COD || '',
          'CB1DESC': item.CB1DESC || '',
          'CZ08LOTE': item.CZ08LOTE || '',
          'DZ08DATA': inventario.DZ08DATA || '',
          'CZ08STATUS': inventario.CZ08STATUS || '',
          'CZ08AREA': item.CZ08AREA || '',
          'CZ08USER': item.CZ08USER || '',
          'CZ08ESTOQU': item.CZ08ESTOQU || '',
          'CUSRNOME': item.CUSRNOME || '',
        };
        return {
          'Cód. Inventário': dadosExcel.CZ08COD,
          'Produto': dadosExcel.CB8PRODUTO,
          'Descrição': dadosExcel.CB1DESC,
          'Lote': dadosExcel.CZ08LOTE,
          'Data': dadosExcel.DZ08DATA,
          'Status': dadosExcel.CZ08STATUS,
          'Área': dadosExcel.CZ08AREA,
          'Usuário': dadosExcel.CZ08USER,
          'Nome do Usuário': dadosExcel.CUSRNOME,
          'Estoque': dadosExcel.CZ08ESTOQU,
          
        };
      });
      this.excelService.exportAsExcelFile(lista_excel, `Relatório Inventário - ${row.CZ08COD}`);
    });
  }
}

